import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { TripAdvisorRating as TripAdvisorRating$2, Header, Grade, ImageContainer, RatingImageWrapper, RatingImage, Label, LinkContainer, Subtext } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import ArrowLink from '../Link/ArrowLink.js';

var _excluded = ["rating", "header", "text", "onClick", "linkText", "subText", "responsive", "hideRatingDesktop", "hideRatingAll", "hideOwl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TripAdvisorRating = function TripAdvisorRating(_ref) {
  var rating = _ref.rating,
      header = _ref.header,
      text = _ref.text,
      onClick = _ref.onClick,
      linkText = _ref.linkText,
      subText = _ref.subText,
      responsive = _ref.responsive,
      hideRatingDesktop = _ref.hideRatingDesktop,
      hideRatingAll = _ref.hideRatingAll,
      hideOwl = _ref.hideOwl,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (typeof rating !== 'number') {
    return false;
  }

  var displayRating = '';

  if (rating && !hideRatingAll) {
    displayRating = rating.toString().replace('.', ',');

    if (displayRating.indexOf(',') < 0) {
      displayRating += ',0';
    }
  }

  var getRatinginPixels = function getRatinginPixels(ratingValue) {
    var ratingInPixels = 36;
    ratingInPixels += Math.floor(ratingValue) * 15;

    if (ratingValue % 1 !== 0) {
      ratingInPixels += 7;
    }

    if (hideOwl) {
      ratingInPixels -= 33;
    }

    return ratingInPixels;
  };

  if (rating < 0.5) {
    return null;
  }

  return /*#__PURE__*/jsxs(TripAdvisorRating$2, _objectSpread(_objectSpread({
    responsive: responsive
  }, rest), {}, {
    children: [header && /*#__PURE__*/jsx(Header, {
      children: header
    }), displayRating && /*#__PURE__*/jsx(Grade, {
      hideRatingDesktop: hideRatingDesktop,
      responsive: responsive,
      children: displayRating
    }), /*#__PURE__*/jsx(ImageContainer, {
      responsive: responsive,
      children: /*#__PURE__*/jsx(RatingImageWrapper, {
        responsive: responsive,
        removeOwlPixels: hideOwl ? -33 : 0,
        children: /*#__PURE__*/jsx(RatingImage, {
          hideRatingDesktop: hideRatingDesktop,
          alt: "Tripadvisor ".concat(displayRating),
          ratingInPixels: getRatinginPixels(rating),
          removeOwlPixels: hideOwl ? -33 : 0
        })
      })
    }), text && /*#__PURE__*/jsx(Label, {
      responsive: responsive,
      children: text
    }), linkText && /*#__PURE__*/jsx(LinkContainer, {
      responsive: responsive,
      children: /*#__PURE__*/jsx(ArrowLink, {
        className: "sg-trip-advisor-rating-link",
        onClick: onClick,
        children: linkText
      })
    }), subText && /*#__PURE__*/jsx(Subtext, {
      responsive: responsive,
      children: subText
    })]
  }));
};

TripAdvisorRating.defaultProps = {
  responsive: false,
  hideRatingDesktop: false,
  hideRatingAll: false,
  hideOwl: false,
  linkText: null,
  header: null,
  text: null,
  onClick: null,
  subText: null
};
var TripAdvisorRating$1 = TripAdvisorRating;

export { TripAdvisorRating$1 as default };
//# sourceMappingURL=TripAdvisorRating.js.map
